import { render, staticRenderFns } from "./RechargePriceCreateForm.vue?vue&type=template&id=52be9de2&"
import script from "./RechargePriceCreateForm.vue?vue&type=script&lang=js&"
export * from "./RechargePriceCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports